import { AppRole, isAppRole } from './roles';

export function extractRolesFromClaims(claims: Record<string, unknown>): AppRole[] {
  const toolClaims = claims['project_acceptance'];
  if (typeof toolClaims === 'object' && toolClaims !== null) {
    const toolClaimObj = toolClaims as Record<string, unknown>;
    const roles = toolClaimObj['roles'];
    const admin = toolClaimObj['admin'];

    let resultRoles: AppRole[] = [];
    if (Array.isArray(roles)) {
      resultRoles = roles.filter(isAppRole);
    }

    if (admin === true && !resultRoles.includes('admin')) {
      resultRoles.push('admin');
    }
    return resultRoles;
  }
  return [];
}

